import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthenticationService } from '../../services/auth/authentication.service';
import { catchError, map, of, take, tap } from 'rxjs';

export const guestGuard: CanActivateFn = () => {
  const authenticationService = inject(AuthenticationService);
  const router = inject(Router);

  // If already known to be authenticated, redirect immediately
  if (authenticationService.isAuthenticated) {
    return router.createUrlTree([
      authenticationService.accountType === 'ADMIN' ? '/admin' : '/user',
    ]);
  }

  // Otherwise check session (for page refresh case)
  return authenticationService.checkSession().pipe(
    take(1),
    map((isValid) => {
      if (isValid) {
        return authenticationService.accountType === 'ADMIN'
          ? router.createUrlTree(['/admin'])
          : router.createUrlTree(['/user']);
      } else {
        return true;
      }
    }),
    catchError((error) => {
      return of(true);
    }),
  );
};
